import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { Page, State } from '../components';

interface Agent {
  id: string;
  publicId: string;
  displayName: string;
  greeting: string;
  primaryColor: string;
  isActive: boolean;
  _count: { documents: number };
  allowedOrigins: unknown[];
}

export function AgentsPage() {
  const query = useQuery({
    queryKey: ['agents'],
    queryFn: () => api<{ data: Agent[] }>('/api/v1/agents'),
  });
  return (
    <Page
      title="AI agents"
      description="Each agent has isolated instructions, knowledge, and origin rules."
      actions={
        <Link className="button primary" to="/agents/new">
          Create agent
        </Link>
      }
    >
      <State loading={query.isLoading} error={query.error} empty={query.data?.data.length === 0}>
        <div className="card table-scroll">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Origins</th>
                <th>Documents</th>
                <th>Public ID</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {query.data?.data.map((agent) => (
                <tr key={agent.id}>
                  <td>
                    <span className="color-dot" style={{ background: agent.primaryColor }} />
                    {agent.displayName}
                  </td>
                  <td>
                    <span className={`badge ${agent.isActive ? 'ready' : ''}`}>
                      {agent.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{agent.allowedOrigins.length}</td>
                  <td>{agent._count.documents}</td>
                  <td>
                    <code>{agent.publicId}</code>
                  </td>
                  <td>
                    <Link to={`/agents/${agent.id}`}>Configure</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </State>
    </Page>
  );
}
